import { z } from 'zod';
import { dataHoraSchema, slugSchema } from './comum.js';
/** Vitrine de portfolio: agrupa sites internos e links externos por aba. */
export const itemVitrineSchema = z.object({
    id: z.uuid(),
    tipo: z.enum(['internal', 'external']),
    clienteId: z.uuid().nullable(),
    urlExterna: z.string().nullable(),
    tituloExterno: z.string().nullable(),
    aba: z.string(),
    ordem: z.number().int().default(0),
});
export const vitrineSchema = z.object({
    id: z.uuid(),
    slug: slugSchema,
    nome: z.string(),
    criadoEm: dataHoraSchema,
    itens: z.array(itemVitrineSchema).default([]),
});
export const salvarVitrineSchema = z.object({
    id: z.uuid().optional(),
    slug: slugSchema,
    nome: z.string().min(1),
    itens: z.array(itemVitrineSchema.omit({ id: true }).partial({ ordem: true })).default([]),
});
//# sourceMappingURL=vitrine.js.map